import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react';
import {useEffect, useState} from 'react';
import {SingleTerm} from './SingleTerm';
import {toJS} from 'mobx';

export const LinksList = observer(({kwUpdate, setVisible}:any) => {
  const {
    contentOptimizer: {
      currentPage: {
        getlinksForInsertion,
        setLinkActiveTerm,
        getstagingLinkSuggestions,
        setStagingLinkSuggestions,
        content,
        taLinkSuggestionLoading,
      },
    }} = useStore('');

  const [finalTermsList, setFinalTermsList] = useState([]);
  const [filter, setFilter] = useState([]);

  function arrayToObject(givenValue) {
    const expectedValue = {};
    givenValue.forEach(item => {
      // Assuming 'url' is unique for each item
      if (!expectedValue[item.url]) {
        expectedValue[item.url] = {title: item.title, keywords: item.keywords};
      }
    });
    return expectedValue;
  }

  const loadLinksData = (linksData:any) => {
    // update staginglinksuggestion to keep a full record for save api
    const expectedData = [];
    for (const outerArray of linksData) {
      for (const innerArray of outerArray) {
        expectedData.push(innerArray.itemIndex);
      }
    }
    const data = getstagingLinkSuggestions?.map((item:any)=>{
      if (expectedData.includes(item.itemIndex)) {
        return item;
      } else {
        return {...item, status: 'default'};
      }
    });
    setStagingLinkSuggestions([...data]);
    // filter duplicate data if any
    const uniqueData = [];
    const seenSet = new Set();

    for (const array of linksData) {
      const stringRepresentation = JSON.stringify(array);
      if (!seenSet.has(stringRepresentation)) {
        uniqueData.push(array);
        seenSet.add(stringRepresentation);
      }
    }
    return uniqueData;
  };

  useEffect(() => {
    setFinalTermsList([]);
    if (getstagingLinkSuggestions?.length) {
      let suggestionList = [];
      const allLinks = arrayToObject(content?.internalLinkSuggestionsV2?.allLinks.map((link:any)=> link?.url?.endsWith('/') ? {...link} : {...link, url: `${link?.url}/`}));
      const getTerms = (term:any) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(term?.suggestion, 'text/html');
        // Find elements with classname 'hero'
        const elements = doc.querySelectorAll('.linkInsertionChange');
        // Extract innerText from each element
        elements.forEach((ele:any)=>{
          suggestionList.push({keyword: ele.innerText, status: 'default'});
        });
      };
      const formattedArray = {};
      // create a format and seprate arrays based on link
      getstagingLinkSuggestions?.forEach((term:any)=>{
        if (term.isSuggestion) {
          if (!formattedArray[term?.linksIncluded[0]]) {
            formattedArray[term?.linksIncluded[0]] = [];
          }
          formattedArray[term?.linksIncluded[0]].push(term);
        }
      });
      const resultArray = Object.values(formattedArray).map((arr:any, indx)=>{
        return arr?.map((arrTwo, indexx)=>{
          suggestionList=[];
          getTerms(arrTwo);
          return {display: indx== 0 ? true: false, itemIndex: arrTwo.itemIndex, index: indexx, link: arrTwo?.linksIncluded[0], suggestion: suggestionList?.length ? suggestionList : [], title: allLinks[arrTwo?.linksIncluded[0]]?.title || '', keywords: toJS(allLinks[arrTwo?.linksIncluded[0]]?.keywords), status: arrTwo?.status};
        });
      });
      setFinalTermsList([...resultArray]);
    }
  }, [taLinkSuggestionLoading, getlinksForInsertion, kwUpdate]);

  useEffect(()=>{
    let filteredValue = [];
    setFilter([]);
    if (kwUpdate.status) {
      // append data from sourced record when checkbox checked in keyword
      const addData = finalTermsList.filter((item:any)=> item[0].keywords?.includes(kwUpdate.kw));
      filteredValue = [...addData.map((val:any)=> val.map((value:any)=> ({...value, status: 'default'}))), ...filter];
      const returnedData = loadLinksData([...filteredValue]);
      setFilter([...returnedData]);
    } else if (kwUpdate.status == false) {
      // remove data from listed record when checkbox checked in keyword
      const filterMatch = filter?.filter((item:any)=> !item[0]?.keywords?.includes(kwUpdate.kw));
      filteredValue = [...filterMatch];
      const returnedData = loadLinksData([...filteredValue]);
      setFilter([...returnedData]);
    } else {
      filteredValue = [...finalTermsList];
      setFilter([...filteredValue]);
    }
    // open first card whenever data filter
    if (filteredValue?.length) {
      const firstTerm = {...filteredValue[0][0]};
      const updatedValues = {
        class: firstTerm.suggestion[0]?.keyword?.replaceAll(' ', '-') + `${firstTerm.itemIndex}`,
        term: firstTerm.suggestion[0]?.keyword,
        order: 0,
        itemIndex: firstTerm.itemIndex,
      };
      setLinkActiveTerm(updatedValues);
    }
  }, [kwUpdate, finalTermsList]);


  return <div style={{display: 'flex', flexDirection: 'column', height: '555px'}}>
    {filter?.map((term, idx) => {
      return <SingleTerm kwUpdate={kwUpdate} setVisible={setVisible} finalTermsList={filter} setFinalTermsList={setFilter} term={term} key={idx}/>;
    })}
  </div>;
});
